import { render, staticRenderFns } from "./CardOnSend.vue?vue&type=template&id=736d5a89&"
import script from "./CardOnSend.vue?vue&type=script&lang=js&"
export * from "./CardOnSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports